import styles from "../../styles/common/Badge.module.scss"
import clsx from "clsx";

import {ReactNode} from "react";
import {cStatusProps} from "../../utils";

interface BadgeProps extends cStatusProps{
  extraClassName?: string;
  text?: string;
  badgeStyle?: "pill" | "ghost";
  badgeSize?: "md" | "lg";
  children?: ReactNode;
}
function Badge(
  {
    extraClassName,
    type = "default",
    text,
    badgeStyle,
    badgeSize,
    children,
  }:BadgeProps) {

  return (
    <span
      className={clsx(styles.cBadge, "c-badge", extraClassName && extraClassName)}
      data-badge-type={type}
      data-badge-style={badgeStyle}
      data-badge-size={badgeSize}
    >
      <span className="c-badge-content">
        {text? text : children}
      </span>

    </span>
  );
}

export default Badge;